// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Graficos_PegagraficoprincipalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Graficos_PegagraficoprincipalResponseDados {
dias_filtro_array: string[]
orcamentos_valores: number[]
compromissos_por_data_cadastro_valores: number[]
compromissos_para_aquele_dia_valores: number[]
compromissos_previstos_para_aquele_dia_valores: number[]
}

export type Graficos_PegagraficoprincipalResponse = ApiResponse<Graficos_PegagraficoprincipalResponseDados>;

registerResponseContract('Graficos_PegagraficoprincipalResponse', {
  dias_filtro_array:                              { type: 'array',   required: true },
  orcamentos_valores:                             { type: 'array',   required: true },
  compromissos_por_data_cadastro_valores:         { type: 'array',   required: true },
  compromissos_para_aquele_dia_valores:           { type: 'array',   required: true },
  compromissos_previstos_para_aquele_dia_valores: { type: 'array',   required: true },
})
